import { fetchRzzroCommodity } from "./api/metals/RzzroApi.js";
import { METAL_TITANIUM_EUR_PER_GRAM } from "../constants/MetalNeedHorizonConfig.js";

let titaniumPriceCache = {
  eurPerGram: null,
  lastUpdate: 0,
  source: null,
};

const CACHE_DURATION = 60 * 60 * 1000; // 1 h (Rzzro: 100 req/h)
const MT_TO_GRAMS = 1_000_000;

/**
 * Intenta obtener precio de titanio desde Rzzro; si no existe, usa el valor
 * manual de MetalNeedHorizonConfig.js (METAL_TITANIUM_EUR_PER_GRAM).
 */
export const getTitaniumPrice = async (forceRefresh = false) => {
  const now = Date.now();

  if (!forceRefresh && titaniumPriceCache.eurPerGram != null) {
    const cacheAge = now - titaniumPriceCache.lastUpdate;
    if (cacheAge < CACHE_DURATION) {
      return {
        eurPerGram: titaniumPriceCache.eurPerGram,
        source: titaniumPriceCache.source,
        timestamp: new Date(titaniumPriceCache.lastUpdate),
        fromCache: true,
      };
    }
  }

  // 1) Intentar Rzzro (actualmente no expone titanio en API pública)
  try {
    const rzzro = await fetchRzzroCommodity("titanium");
    if (rzzro?.price) {
      // Rzzro devuelve USD/mt → €/g requiere tipo de cambio; de momento solo USD/mt
      const eurPerGram = rzzro.price / MT_TO_GRAMS;
      titaniumPriceCache = {
        eurPerGram,
        lastUpdate: now,
        source: "rzzro.com",
      };
      return {
        eurPerGram,
        source: "rzzro.com",
        timestamp: new Date(now),
        fromCache: false,
      };
    }
  } catch (error) {
    console.warn("Titanio: Rzzro no disponible o sin dato:", error.message);
  }

  // 2) Precio manual configurado
  if (METAL_TITANIUM_EUR_PER_GRAM != null && METAL_TITANIUM_EUR_PER_GRAM > 0) {
    titaniumPriceCache = {
      eurPerGram: METAL_TITANIUM_EUR_PER_GRAM,
      lastUpdate: now,
      source: "config manual",
    };
    return {
      eurPerGram: METAL_TITANIUM_EUR_PER_GRAM,
      source: "config manual",
      timestamp: new Date(now),
      fromCache: false,
    };
  }

  return {
    eurPerGram: null,
    source: null,
    timestamp: new Date(now),
    fromCache: false,
  };
};
